module.exports = __webpack_public_path__ + "static/media/email.755c578c.svg";